// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <div class='error-snackbar'>
    <v-snackbar :timeout="6000" top v-model="visible">
      {{ text }}
      <v-btn text class="pink--text" @click.native="visible = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    name: 'error-snackbar',

    data () {
      return {
        isActive: this.value,
        text: '',
        visible: false
      }
    },

    props: ['value'],

    watch: {
      value (val) {
        if (val) {
          this.text = val
        }
        this.$emit('input', null)
        this.visible = true
      }
    }
  }
</script>




// WEBPACK FOOTER //
// ErrorSnackbar.vue?48dbd8fe